<template>

  <div>

    <add-new :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive" :user-data="userData"
      @refetch-data="refetchData" />

    <list-filters :status-filter.sync="statusFilter" :plan-filter.sync="planFilter" :role-filter.sync="roleFilter"
      :role-options="roleOptions" />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Show</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="8">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-5" placeholder="Search..." />
              <!-- <b-button
                variant="primary"
                @click="AddData()"
              >
                <span class="text-nowrap">Upload Planning</span>
              </b-button> -->
              <b-button id="toggle-btn" v-b-modal.modal-prevent-closing variant="primary" class="mr-1">
                <span class="text-nowrap">Upload Data</span>
              </b-button>
              &nbsp;
              &nbsp;
              &nbsp;
              &nbsp;
              <a download="Template Planning" :href="urldownload">
                <b-button variant="primary">
                  <span class="text-nowrap">Download Template Weekly</span>
                </b-button></a>
              &nbsp;
              &nbsp;
              &nbsp;
              &nbsp;
              <a download="Template Planning" :href="urldownload2">
                <b-button variant="primary">
                  <span class="text-nowrap">Download Template Monthly</span>
                </b-button></a>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table ref="refUserListTable" class="position-relative" :items="fetchData" responsive :fields="tableColumns"
        :busy.sync="isBusy" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc" striped>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-button variant="outline-primary" disabled class="mr-1">
              <b-spinner small />
              Loading...
            </b-button>
          </div>
        </template>

        <template #cell(kode_mold)="data">
          <span class="text-nowrap">
            {{ data.value }}
          </span>
        </template>

        <template #cell(jenis_ukuran)="data">
          <span class="text-nowrap">
            {{ data.value }}
          </span>
        </template>

        <template #cell(keterangan)="data">
          <span class="text-nowrap">
            {{ data.value }}
          </span>
        </template>

        <template #cell(tanggal)="data">
          <span class="text-nowrap">
            {{ data.value }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <div style="line-height:80%;">
              <br>
            </div>
            <feather-icon :id="`invoice-row-${data.item.id}-send-icon`" icon="EditIcon" class="cursor-pointer"
              :class="`text-primary`" size="17" @click="EditData(data.item)" />
            <b-tooltip :title="`Edit Data`" class="cursor-pointer" :target="`invoice-row-${data.item.id}-send-icon`" />
            &nbsp;
            <feather-icon :id="`invoice-row2-${data.item.id}-send-icon`" icon="Trash2Icon" class="cursor-pointer"
              :class="`text-danger`" size="17" @click="showMsgBoxTwo(data.item.id)" />
            <b-tooltip :title="`Delete Data`" class="cursor-pointer"
              :target="`invoice-row2-${data.item.id}-send-icon`" />
          </div>
          <div style="line-height:80%;">
            <br>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}
              entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

            <b-pagination v-model="currentPage" :total-rows="totalData" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
      <!-- modal -->
      <b-modal id="modal-prevent-closing" ref="my-modal" title="Upload Your File" ok-title="Submit"
        cancel-variant="outline-secondary" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-col cols="12" md="12" class="mb-md-0 mb-2">
            <label>Jenis</label>
            <v-select v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title"
              :options="option" />
          </b-col> <br>
          <b-col cols="12" md="12" class="mb-md-0 mb-2">
            <b-form-group :state="nameState" label="Upload File" label-for="name-input"
              invalid-feedback="Name is required">

              <b-form-file id="name-input" v-model="name" accept=".xlsx" placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..." required />
              <small-text>
                <span> &nbsp;This file must format </span>
                <code>&lt;.xlsx&gt;</code>
              </small-text>
            </b-form-group>
          </b-col>
        </form>
      </b-modal>

      <template #code>
        {{ codePrevent, codeFile }}
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BPagination, BTooltip, BModal, VBModal, BFormFile, BSpinner,
  // BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import ListFilters from './ListFilters.vue'
// eslint-disable-next-line import/no-cycle
import useList from './useList'
import StoreModule from '../StoreModule'
import AddNew from './AddNew.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ListFilters,
    AddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BTooltip,
    BSpinner,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BModal,
    BFormFile,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      name: '',
      nameState: null,
      submittedNames: [],
      isBusy: false,
      urldownload: `${useAppConfig().AxiosUrl}api_mes/cttp-planning-pipa-download-weekly`,
      urldownload2: `${useAppConfig().AxiosUrl}api_mes/cttp-planning-pipa-download-monthly`,
      selected: null,
      option: [{ title: 'Weekly' }, { title: 'Monthly' }],
    }
  },
  methods: {
    async showMsgBoxTwo(id) {
      this.boxTwo = id
      this.$bvModal
        .msgBoxConfirm('Are You Sure To Delete This Data?', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: true,
          centered: true,
        })
        .then(async value => {
          this.boxTwo = value
          console.log(value)
          if (value === true) {
            const params = new URLSearchParams()
            params.append('param', 'delete')
            params.append('id', id)
            const result = await axios.post(`${useAppConfig().AxiosUrl}api_mes/ctpp-planning/delete`, params)
            if (result.data.message === 'Data Deleted') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Notification',
                  icon: 'BellIcon',
                  text: result.data.message,
                  variant: 'success',
                },
              })
              this.refetchData()
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  icon: 'BellIcon',
                  text: 'Error Deleting Data',
                  variant: 'danger',
                },
              })
              // console.log(result)
            }
          }
        })
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name)
      const params = new FormData()
      params.append('file', this.name)
      params.append('nik', localStorage.getItem('nik'))
      // const result = await axios.post(`${useAppConfig().AxiosUrl}api_mes/group-item-ctr/delete`, params)
      if (this.selected.title === 'Monthly') {
        const result = await axios.post(`${useAppConfig().AxiosUrl}api_mes/cttp-planning-pipa/upload-monthly`, params, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        if (result.data.message === 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              text: 'Data Uploaded',
              variant: 'success',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              text: result.data.message,
              variant: 'danger',
            },
          })
        }
      }
      else if (this.selected.title === 'Weekly') {
        const result = await axios.post(`${useAppConfig().AxiosUrl}api_mes/cttp-planning-pipa/upload-weekly`, params, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        if (result.data.message === 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              text: 'Data Uploaded',
              variant: 'success',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              text: result.data.message,
              variant: 'danger',
            },
          })
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'BellIcon',
            text: result.data.message,
            variant: 'danger',
          },
        })
      }

      this.refetchData()

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const { AxiosUrl } = useAppConfig()

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, StoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const blankTask = {
      kode_item: '',
      description: '',
      group_item: '',
      action: 'Add',
    }

    const roleOptions = ref([])

    onMounted(async () => {
      // const params = new URLSearchParams()
      const result = await axios.post(`${useAppConfig().AxiosUrl}api_mes/ctpp-mold/sitelist`, { emp_id: localStorage.getItem('id') }) // id_group_oee 23 = Fitting Karawang
      const dataAPI = result.data.data
      const combo = []
      // eslint-disable-next-line no-plusplus
      for (let i = 0, len = dataAPI.length; i < len; i++) {
        combo.push({ label: `${dataAPI[i].keterangan}`, value: dataAPI[i].site_qad })
      }
      roleOptions.value = combo
    })

    const isAddNewUserSidebarActive = ref(false)
    const userData = ref(JSON.parse(JSON.stringify(blankTask)))

    const EditData = taskData => {
      userData.value = taskData
      isAddNewUserSidebarActive.value = true
    }

    const AddData = () => {
      userData.value = blankTask
      isAddNewUserSidebarActive.value = true
    }

    const {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      planFilter,
      statusFilter,
      roleFilter,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
    } = useList()

    return {
      userData,
      AddData,
      EditData,

      // Sidebar
      isAddNewUserSidebarActive,

      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      roleOptions,

      // UI
      planFilter,
      statusFilter,
      roleFilter,

      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
